<template>
  <v-card v-if="auditPeriods">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('audit.users.search')"
        single-line
        hide-details
        color="secondary"
      ></v-text-field>
    </v-card-title>

    <AuditPeriodTableTable :auditPeriods="auditPeriods" :search="search"></AuditPeriodTableTable>

    <v-card-actions>
      <v-btn v-if="$auth.may(['admin:users'])" @click="downloadReport(false)" color="secondary">
        {{ $t("auditor.auditPeriods.downloadReport") }}
      </v-btn>

      <v-btn v-if="$auth.may(['admin:users'])" @click="downloadReport(true)" color="secondary">
        {{ $t("auditor.auditPeriods.downloadReportByIsin") }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="600" v-if="$auth.may(['audit:finish']) && closeable > 0">
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" class="ml-2">
            {{ $t("auditor.closeAllFunds", { count: closeable }) }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t("auditor.closeFunds.confirmation.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('auditor.closeFunds.confirmation.description')" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="warning" @click="dialog = false">
              {{ $t("auditor.closeFunds.confirmation.cancel") }}
            </v-btn>

            <v-btn color="primary" @click="closeFunds" :loading="closing">
              {{ $t("auditor.closeFunds.confirmation.accept") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { length, filter, includes, propSatisfies, __, curry, map, sum } from "ramda";
import download from "@/utils/download";
import AuditPeriodReportQuery from "@/gql/queries/AuditPeriodReportQuery.gql";
import FinishAuditOfCloseableFundsMutation from "@/gql/mutations/FinishAuditOfCloseableFundsMutation.gql";
import AuditPeriodTableTable from "./AuditPeriodTableTable.vue";

const countFunds = curry((prop, states, funds) => length(filter(propSatisfies(includes(__, states), prop), funds)));

export default {
  components: { AuditPeriodTableTable },

  props: {
    year: {
      type: Number,
      required: true,
    },

    auditPeriods: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      search: "",
      closing: false,
      dialog: false,
    };
  },

  computed: {
    closeable() {
      return sum(map(({ funds }) => countFunds("mayBeClosed", [true], funds), this.auditPeriods));
    },
  },

  methods: {
    async downloadReport(byIsin = false) {
      const filename = !byIsin ? `audit-period-report_${this.year}.csv` : `audit-period-report_${this.year}_ISIN.csv`;
      const result = await this.$apollo.query({
        query: AuditPeriodReportQuery,
        fetchPolicy: "network-only",
        variables: {
          year: this.year,
          byIsin,
        },
      });
      download(filename, result.data.auditPeriodReport);
    },

    async closeFunds() {
      this.closing = true;
      await this.$apollo.mutate({
        mutation: FinishAuditOfCloseableFundsMutation,
        variables: {
          year: this.year,
        },
      });
      this.closing = false;
    },
  },
};
</script>
